module.exports = __webpack_public_path__ + "media/images/slack-28d05039bc626c1ad70fa50a657aa713.svg";